import APIClient from '@/shared/http/clients/api'

const resourceName = 'REInsumo'
const APIBaseURLRealEstate = process.env.APIBaseURLRealEstate

const Post = (data = {}, config = {}) => APIClient.post(`${APIBaseURLRealEstate}/${resourceName}/Post`, data, config)
const GetAllInsumos = (data = {}, config = {}) => APIClient.get(`${APIBaseURLRealEstate}/${resourceName}/GetAll`, data, config)

const InputRepository = {
  Post,
  GetAllInsumos
}

export default InputRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/realestate/input.js